@if (!!system) {
    @if (isEditSystemPage) {
        <adapt-toolbar-title>
            <div class="d-flex flex-row align-items-center">
                <h2>{{ system!.name }}</h2>
                @if (system!.labelLocations?.length) {
                    <adapt-display-labels class="ms-2"
                                          [labelLocations]="system!.labelLocations"></adapt-display-labels>
                }
                @if (isEditing) {
                    <button class="ms-1"
                            [disabled]="layoutManager?.isEditing"
                            adaptButton="editBorderless"
                            (click)="editSystem().subscribe()"></button>
                }
            </div>
        </adapt-toolbar-title>
        @if (canEdit$ | async) {
            <div adaptToolbarContent
                 [ordinal]="1000">
                <adapt-menu [items]="configureSystemMenu"
                            [disabled]="layoutManager?.isEditing"></adapt-menu>
            </div>
        }
        @if (canEdit$ | async) {
            <div adaptToolbarContent
                 [ordinal]="900"
                 class="d-flex align-items-center">
                @if (isEditing) {
                    <adapt-system-component-add-menu [ngClass]="{
                            'pulsing-icon': systemComponents.length < 1,
                        }"
                                                     class="system-component-add-menu"
                                                     [system]="system"
                                                     [disabled]="layoutManager?.isEditing"
                                                     (systemComponentAdded)="onSystemComponentAdded($event)">
                    </adapt-system-component-add-menu>
                }
            </div>
        }
    } @else {
        @if (showTitle) {
            <h3 class="mb-3 mt-n3 d-flex align-items-center">
                <adapt-link-system [system]="system"
                                   [showNavIcon]="true"
                                   [showLabels]="true"
                                   data-test="system-link"></adapt-link-system>
            </h3>
        }
    }
    <ng-container *adaptLoading="!isInitialised">
        <adapt-layout-manager innerClass="h-100 m-0"
                              [showEditLayoutButton]="false"
                              [allowEditing]="isEditing && (canEdit$ | async) && systemComponents.length > 0"
                              [entity]="system"
                              (initialised)="onLayoutManagerInitialised()"
                              *adaptRerender="editingDetailsRerender">
            <adapt-layout-column class="col-md-12 bg-white">
                @for (systemComponent of systemComponents; track systemComponent) {
                    <adapt-layout-component id="system-component-{{ systemComponent.systemComponentId }}"
                                            class="mb-4">
                        <adapt-system-component [systemComponent]="systemComponent"
                                                [isEditing]="isEditing"
                                                [isNewlyAdded]="systemComponent.systemComponentId === addedComponentId"
                                                (newComponentAnimated)="onNewComponentAnimated($event)"
                                                [processMapState]="getProcessMapState(systemComponent)"
                                                (processMapStateChange)="onProcessMapStateChanged($event)"
                                                (systemComponentDeleted)="triggerComponentUpdate$.next()"
                                                (componentCopied)="onSystemComponentAdded($event)"></adapt-system-component>
                    </adapt-layout-component>
                }
                <adapt-layout-component id="system-owners"
                                        class="col-md-6">
                    <div *adaptLayoutComponentEnabled="system!.ownerId && systemComponents.length > 0"
                         class="d-flex flex-column mb-3">
                        <div class="d-flex flex-row align-items-baseline mb-2">
                            <h3 class="document-title">System owner</h3>
                            @if (isEditing) {
                                <button class="ms-1"
                                        adaptButton="editBorderless"
                                        (click)="editSystem().subscribe()"
                                        data-test="system-edit"></button>
                            }
                        </div>
                        <adapt-link-person class="mb-2"
                                           [personId]="system!.ownerId"
                                           [showImage]="true"> </adapt-link-person>
                    </div>
                </adapt-layout-component>
                <adapt-layout-component id="system-knowledge-experts"
                                        class="col-md-6">
                    <div *adaptLayoutComponentEnabled="system!.systemKnowledgeExperts.length > 0 && systemComponents.length > 0"
                         class="d-flex flex-column mb-3">
                        <div class="d-flex flex-row align-items-baseline mb-2">
                            <h3 class="document-title">Knowledge experts</h3>
                            @if (isEditing) {
                                <button class="ms-1"
                                        adaptButton="editBorderless"
                                        (click)="editSystem().subscribe()"></button>
                            }
                        </div>
                        <div class="grid-layout">
                            @for (systemKnowledgeExpert of system!.systemKnowledgeExperts; track systemKnowledgeExpert) {
                                <adapt-link-person class="mb-2"
                                                   [personId]="systemKnowledgeExpert.knowledgeExpertId"
                                                   [showImage]="true"></adapt-link-person>
                            }
                        </div>
                    </div>
                </adapt-layout-component>
                @if (systemComponents.length < 1) { <adapt-layout-component id="call-to-action"
                                            class="h-100">
                        <ng-container *ngTemplateOutlet="noComponentCTA"></ng-container>
                    </adapt-layout-component>
                }
                <adapt-layout-component id="system-locations"
                                        class="pt-3 mb-4">
                    <div *adaptLayoutComponentEnabled="hasLocations"
                         class="d-flex flex-column">
                        @if (otherTeamSystems.length > 0) {
                            <div class="mb-3 d-flex flex-column">
                                <h3 class="document-title">Related groups</h3>
                                <div class="grid-layout">
                                    @for (systemTeam of otherTeamSystems; track systemTeam) {
                                        <adapt-link-team class="mb-2"
                                                         [team]="systemTeam.team"
                                                         [showIcon]="true"> </adapt-link-team>
                                    }
                                </div>
                            </div>
                        }
                        @if (otherRoleSystems.length > 0) {
                            <div class="mb-3 d-flex flex-column">
                                <h3 class="document-title">Related roles</h3>
                                <div class="grid-layout">
                                    @for (systemRole of otherRoleSystems; track systemRole) {
                                        <adapt-link-role class="mb-2"
                                                         [role]="systemRole.role"
                                                         [showIcon]="true"> </adapt-link-role>
                                    }
                                </div>
                            </div>
                        }
                        @if (zoneSystems.length > 0) {
                            <div class="mb-3 d-flex flex-column">
                                <h3 class="document-title">Related zones</h3>
                                <div class="grid-layout">
                                    @for (zoneLocation of zoneSystems; track zoneLocation) {
                                        <adapt-zone-label class="mb-2"
                                                          [zone]="zoneLocation.zone"></adapt-zone-label>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </adapt-layout-component>
            </adapt-layout-column>
        </adapt-layout-manager>
    </ng-container>
    <ng-template #noComponentCTA>
        @if (!isEditSystemPage) {
            <div>
                <ng-container [ngTemplateOutlet]="systemContentHelpText"></ng-container>
                <button adaptCallToActionButton
                        adaptButtonIcon="navigateTo"
                        [adaptBlockingClick]="gotoSystemPage"
                        [adaptBlockingClickParam]="system">Define the system</button>
            </div>
        } @else {
            <adapt-call-to-action [fullPage]="true">
                <ng-container [ngTemplateOutlet]="systemContentHelpText"></ng-container>
            </adapt-call-to-action>
        }
        <ng-template #systemContentHelpText>
            <div class="d-print-none">
                <h3 class="mt-2 mb-3">No elements have been defined for this system yet.</h3>
                <p>When describing your system, use elements that will make it easy for people to understand and implement the system.</p>
                <p>To do this, use any of the available system element types:</p>
                <ul class="list-content">
                    <li>Texts</li>
                    <li>Diagrams</li>
                    <li>Task Maps</li>
                    <li>Documents</li>
                    <li>Videos</li>
                </ul>
            </div>
        </ng-template>
    </ng-template>
} @else {
    <div class="alert alert-info">No system selected</div>
}
